import React from "react";
import { Row, Col } from "antd";
import { ProCard } from "@ant-design/pro-components";
import PageVisits from "./PageVisits";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";

export default function TableSection() {
  const { t } = useTranslation();
  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <ProCard className={styles.tableCard}>
            <PageVisits title={t("pages.dashboard.analytics.mostVisited")} />
          </ProCard>
        </Col>

        <Col span={12}>
          <ProCard className={styles.tableCard}>
            <PageVisits title={t("pages.dashboard.analytics.mostVisited")} />
          </ProCard>
        </Col>
      </Row>
      <ProCard className={styles.tableCard}>
        <PageVisits title={t("pages.dashboard.analytics.mostVisited")} />
      </ProCard>
    </>
  );
}
